__turbopack_context__.v({
  "active": "section-nav-module__JPi3SG__active",
  "cta": "section-nav-module__JPi3SG__cta",
  "inner": "section-nav-module__JPi3SG__inner",
  "link": "section-nav-module__JPi3SG__link",
  "list": "section-nav-module__JPi3SG__list",
  "nav": "section-nav-module__JPi3SG__nav",
  "progress": "section-nav-module__JPi3SG__progress",
  "progressBar": "section-nav-module__JPi3SG__progressBar",
  "slot": "section-nav-module__JPi3SG__slot",
  "stuck": "section-nav-module__JPi3SG__stuck",
});
